import { render, staticRenderFns } from "./player-message-item.vue?vue&type=template&id=6c619e08&scoped=true"
import script from "./player-message-item.vue?vue&type=script&lang=js"
export * from "./player-message-item.vue?vue&type=script&lang=js"
import style0 from "./player-message-item.vue?vue&type=style&index=0&id=6c619e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c619e08",
  null
  
)

export default component.exports